import { useEffect, useRef } from 'react';
import { getFirstShadowDomChild } from '@guest-widgets/shared/src/utils/getFirstShadowDomChild';

import { useUpsell } from '../contexts/upsellContext/upsellContext';

export const useGetDrawerContainerElement = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  const { setContainer } = useUpsell();

  useEffect(() => {
    if (ref.current) {
      const container = getFirstShadowDomChild(ref.current);
      setContainer(container);
    }
  }, [ref.current]);

  return { ref };
};
